module.exports = __webpack_public_path__ + "static/img/direct_hit_movie_thum_01_no_btn.af4b253.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/movie/direct_hit_movie_thum_01_no_btn.jpg
// module id = IUY5
// module chunks = 0